export const TOAST_MESSAGE_DURATION_SECONDS = 10;

export const SNACKBAR_TEXT = {
    DELETE_ZONE_SUCCESS_TEXT: 'Zone successfully deleted',
    DELETE_ZONE_ERROR_TEXT: 'Error deleting zone. Try again later',
    SAVE_ZONE_SUCCESS_TEXT: 'Zone successfully saved',
    SAVE_ZONE_ERROR_TEXT: 'Error saving zone. Try again later',
}
